import * as Yup from 'yup';
import { MONEY_DECIMAL_REGEX } from '@/helpers/common';

export const VALIDATION_SCHEMA = t =>
  Yup.object().shape({
    account: Yup.object().shape({
      id: Yup.number().required(),
    }),
    amount: Yup.string()
      .trim()
      .matches(MONEY_DECIMAL_REGEX, t('withdraw_form.val_enter_valid_amount'))
      .required(t('withdraw_form.val_please_enter_amount')),
  });
